import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getHebergements } from "../utils/api";

// ── Icônes ───────────────────────────────────────────────────
const IconSearch = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#7A5A3A" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/>
  </svg>
);
const IconPin = ({ size = 13, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconStar = ({ size = 13, color = "#F5A623" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} stroke={color} strokeWidth="1">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);
const IconFilter = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="4" y1="6" x2="20" y2="6"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
    <line x1="11" y1="18" x2="13" y2="18"/>
  </svg>
);
const IconClose = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M18 6L6 18M6 6l12 12"/>
  </svg>
);
const IconClock = ({ size = 44, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconBuilding = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="3" width="18" height="18" rx="1"/>
    <path d="M3 9h18M3 15h18M9 3v18M15 3v18"/>
  </svg>
);
const IconVilla = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const IconHotel = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M3 22V9l9-7 9 7v13"/>
    <rect x="9" y="14" width="6" height="8"/>
    <rect x="5" y="10" width="3" height="3"/>
    <rect x="16" y="10" width="3" height="3"/>
    <rect x="5" y="15" width="3" height="3"/>
    <rect x="16" y="15" width="3" height="3"/>
  </svg>
);
const IconFlag = ({ size = 16, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
    <line x1="4" y1="22" x2="4" y2="15"/>
  </svg>
);
const IconArrowRight = ({ size = 15, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

// ── Étoiles ──────────────────────────────────────────────────
const Stars = ({ count }) => (
  <div style={{ display: "flex", gap: 2 }}>
    {[1,2,3,4,5].map(i => (
      <svg key={i} width="12" height="12" viewBox="0 0 24 24" fill={i <= count ? "#F5A623" : "#E8DCC8"}>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ))}
  </div>
);

// ── Onglets catégories ────────────────────────────────────────
const CATEGORIES = [
  { key: "appartements", label: "Appartements", Icon: IconBuilding },
  { key: "villas",       label: "Villas",        Icon: IconVilla   },
  { key: "hotels",       label: "Hôtels",        Icon: IconHotel   },
];

export default function ListeHebergements() {
  const navigate = useNavigate();
  const [hebergements, setHebergements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [categorieActive, setCategorieActive] = useState("appartements");

  const [filtres, setFiltres] = useState({
    ville: "toutes",
    prixMax: 500000,
    tri: "note",
    disponibleSeulement: false,
  });

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await getHebergements({ ...filtres, type: categorieActive });
        setHebergements(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [filtres, categorieActive]);

  const hebergementsFiltres = hebergements.filter(h =>
    h.nom.toLowerCase().includes(search.toLowerCase()) ||
    h.ville.toLowerCase().includes(search.toLowerCase()) ||
    (h.quartier || "").toLowerCase().includes(search.toLowerCase())
  );

  const villes = ["toutes", "Dakar", "Saly", "Saint-Louis", "Ziguinchor", "Thiès", "Touba"];
  const formatPrix = (prix) => prix.toLocaleString("fr-FR") + " FCFA";

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin:0; padding:0; box-sizing:border-box; }

        .heberg-card {
          background: white; border-radius: 16px; overflow: hidden;
          border: 1.5px solid rgba(28,16,8,.06); cursor: pointer;
          transition: all .3s; display: flex; flex-direction: column;
        }
        .heberg-card:hover { transform: translateY(-5px); box-shadow: 0 20px 50px rgba(28,16,8,.12); }
        .heberg-img { width: 100%; height: 200px; object-fit: cover; display: block; transition: transform .4s; }
        .heberg-card:hover .heberg-img { transform: scale(1.04); }

        .filter-btn {
          font-family: 'Space Grotesk', sans-serif; font-size: 13px; font-weight: 500;
          padding: 8px 18px; border-radius: 20px; border: 1.5px solid rgba(28,16,8,.12);
          background: white; color: #7A5A3A; cursor: pointer; transition: all .2s; white-space: nowrap;
        }
        .filter-btn:hover { border-color: #C4441A; color: #C4441A; }
        .filter-btn.active { background: #C4441A; color: white; border-color: #C4441A; }

        .search-input {
          flex: 1; border: none; outline: none;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px;
          color: #1C1008; background: transparent; min-width: 0;
        }

        .tag {
          font-family: 'Space Grotesk', sans-serif; font-size: 11px; font-weight: 500;
          background: rgba(196,68,26,.08); color: #C4441A;
          padding: 3px 8px; border-radius: 4px;
        }

        .btn-voir {
          display: flex; align-items: center; gap: 6px;
          background: #C4441A; color: white; border: none;
          padding: 10px 16px; border-radius: 8px;
          font-family: 'Space Grotesk', sans-serif; font-size: 13px; font-weight: 600;
          cursor: pointer; transition: all .3s; white-space: nowrap;
        }
        .btn-voir:hover { background: #A03614; transform: translateY(-1px); }

        .select-input {
          font-family: 'Space Grotesk', sans-serif; font-size: 14px;
          border: 1.5px solid #E8DCC8; border-radius: 8px;
          padding: 10px 14px; color: #1C1008; background: white;
          outline: none; cursor: pointer; width: 100%;
        }
        .select-input:focus { border-color: #C4441A; }

        .categorie-tab {
          display: flex; align-items: center; gap: 8px;
          padding: 10px 22px; border-radius: 10px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px; font-weight: 600;
          border: 2px solid rgba(28,16,8,.1); background: white; color: #7A5A3A;
          cursor: pointer; transition: all .25s; flex-shrink: 0;
        }
        .categorie-tab:hover { border-color: #C4441A; color: #C4441A; }
        .categorie-tab.active { background: #1C1008; color: white; border-color: #1C1008; }

        @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .5s ease forwards; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
        .pulse { animation: pulse 1.5s ease-in-out infinite; }

        .hebergements-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
        @media(max-width:1199px) { .hebergements-grid { grid-template-columns: repeat(2, 1fr); } }
        @media(max-width:767px) {
          .hebergements-grid { grid-template-columns: 1fr; }
          .hero-heberg { padding: 80px 5% 40px !important; }
          .filters-bar { flex-wrap: wrap !important; }
          .categorie-tabs { flex-wrap: wrap !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="hero-heberg" style={{
        background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)",
        padding: "100px 5% 48px", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:"url(https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=1400&q=80)", backgroundSize:"cover", backgroundPosition:"center", opacity:.12 }} />
        <div style={{ position:"absolute", inset:0, backgroundImage:"radial-gradient(circle, rgba(196,68,26,.08) 1px, transparent 1px)", backgroundSize:"26px 26px" }} />

        <div style={{ maxWidth:1200, margin:"0 auto", position:"relative", zIndex:1 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
            <IconFlag size={13} color="#C4441A" />
            <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, fontWeight:700, letterSpacing:3, color:"#C4441A", textTransform:"uppercase" }}>
              Hébergements au Sénégal
            </p>
          </div>
          <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(28px,5vw,56px)", fontWeight:800, color:"white", lineHeight:1.1, letterSpacing:"-1.5px", marginBottom:16 }}>
            Appartements & Villas au{" "}
            <span style={{ color:"#E8834A", fontStyle:"italic" }}>Sénégal</span>
          </h1>
          <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:16, color:"rgba(255,255,255,.6)", marginBottom:32, maxWidth:520 }}>
            Des appartements modernes aux villas de luxe — trouvez l'hébergement idéal pour votre séjour.
          </p>

          {/* Barre de recherche */}
          <div style={{ display:"flex", alignItems:"center", background:"white", borderRadius:10, padding:"8px 8px 8px 20px", gap:12, maxWidth:580, boxShadow:"0 8px 32px rgba(0,0,0,.2)" }}>
            <IconSearch size={18} />
            <input
              className="search-input"
              placeholder="Rechercher un appartement, une villa, une ville..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button onClick={() => setSearch("")} style={{ background:"none", border:"none", cursor:"pointer", color:"#B8A898", display:"flex", alignItems:"center" }}>
                <IconClose size={16} />
              </button>
            )}
          </div>
        </div>
      </section>

      {/* ── BARRE FILTRES + ONGLETS ──────────────────────────── */}
      <section style={{ background:"white", borderBottom:"1px solid rgba(28,16,8,.07)", padding:"16px 5%", position:"sticky", top:68, zIndex:100 }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>

          {/* Ligne 1 : filtres rapides par ville */}
          <div style={{ display:"flex", alignItems:"center", gap:12, overflowX:"auto", paddingBottom:2, marginBottom:14 }} className="filters-bar">
            <button
              onClick={() => setShowFilters(!showFilters)}
              style={{ display:"flex", alignItems:"center", gap:6, fontFamily:"'Space Grotesk',sans-serif", fontSize:13, fontWeight:600, padding:"8px 16px", borderRadius:20, border:"1.5px solid #C4441A", background: showFilters ? "#C4441A" : "white", color: showFilters ? "white" : "#C4441A", cursor:"pointer", flexShrink:0 }}
            >
              <IconFilter size={15} />
              Filtres
            </button>
            <div style={{ width:1, height:24, background:"rgba(28,16,8,.1)", flexShrink:0 }} />
            {villes.map(v => (
              <button key={v} className={`filter-btn ${filtres.ville === v ? "active" : ""}`}
                onClick={() => setFiltres({ ...filtres, ville: v })}
                style={{ flexShrink:0, display:"flex", alignItems:"center", gap:6 }}
              >
                {v === "toutes" && <IconFlag size={12} color={filtres.ville === "toutes" ? "white" : "#C4441A"} />}
                {v === "toutes" ? "Toutes les villes" : v}
              </button>
            ))}
          </div>

          {/* Ligne 2 : Onglets Catégories */}
          <div className="categorie-tabs" style={{ display:"flex", gap:10 }}>
            {CATEGORIES.map(({ key, label, Icon }) => (
              <button
                key={key}
                className={`categorie-tab ${categorieActive === key ? "active" : ""}`}
                onClick={() => { setCategorieActive(key); setSearch(""); }}
              >
                <Icon size={16} color={categorieActive === key ? "white" : "#7A5A3A"} />
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Panel filtres avancés */}
        {showFilters && (
          <div style={{ maxWidth:1200, margin:"16px auto 0" }}>
            <div style={{ display:"flex", gap:20, flexWrap:"wrap", background:"#FAF5EC", borderRadius:12, padding:"20px 24px", border:"1.5px solid rgba(196,68,26,.12)" }}>
              <div style={{ minWidth:200 }}>
                <label style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, fontWeight:700, color:"#7A5A3A", textTransform:"uppercase", letterSpacing:1, display:"block", marginBottom:10 }}>
                  Prix max : {formatPrix(filtres.prixMax)}
                </label>
                <input type="range" min="10000" max="500000" step="10000"
                  value={filtres.prixMax}
                  onChange={e => setFiltres({ ...filtres, prixMax: parseInt(e.target.value) })}
                  style={{ width:"100%", accentColor:"#C4441A" }}
                />
                <div style={{ display:"flex", justifyContent:"space-between", marginTop:4 }}>
                  <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, color:"#B8A898" }}>10 000</span>
                  <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, color:"#B8A898" }}>500 000 FCFA</span>
                </div>
              </div>

              <div style={{ minWidth:180 }}>
                <label style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, fontWeight:700, color:"#7A5A3A", textTransform:"uppercase", letterSpacing:1, display:"block", marginBottom:10 }}>
                  Trier par
                </label>
                <select className="select-input" value={filtres.tri} onChange={e => setFiltres({ ...filtres, tri: e.target.value })}>
                  <option value="note">Meilleure note</option>
                  <option value="prix_asc">Prix croissant</option>
                  <option value="prix_desc">Prix décroissant</option>
                </select>
              </div>

              <button onClick={() => setFiltres({ ville:"toutes", prixMax:500000, tri:"note", disponibleSeulement:false })}
                style={{ alignSelf:"flex-end", fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#C4441A", fontWeight:600, background:"none", border:"none", cursor:"pointer", textDecoration:"underline", paddingBottom:4 }}>
                Réinitialiser
              </button>
            </div>
          </div>
        )}
      </section>

      {/* ── CONTENU PRINCIPAL ────────────────────────────────── */}
      <section style={{ padding:"48px 5% 80px" }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>

          {/* ── CAS HÔTELS : Bientôt disponible ── */}
          {categorieActive === "hotels" && (
            <div className="fade-up" style={{ textAlign:"center", padding:"100px 20px" }}>
              <div style={{ display:"flex", justifyContent:"center", marginBottom:28 }}>
                <div style={{ width:90, height:90, borderRadius:"50%", background:"rgba(196,68,26,.08)", border:"2px dashed rgba(196,68,26,.25)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <IconClock size={44} color="#C4441A" />
                </div>
              </div>
              <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(24px,4vw,38px)", fontWeight:800, marginBottom:14, letterSpacing:"-0.5px" }}>
                Bientôt disponible
              </h2>
              <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:16, color:"#7A5A3A", maxWidth:480, margin:"0 auto 32px", lineHeight:1.7 }}>
                Notre sélection d'hôtels arrive prochainement. En attendant, découvrez nos appartements et villas disponibles dès maintenant.
              </p>
              <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
                <button
                  onClick={() => setCategorieActive("appartements")}
                  style={{ display:"flex", alignItems:"center", gap:8, background:"#C4441A", color:"white", border:"none", padding:"13px 28px", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:700, cursor:"pointer" }}
                >
                  <IconBuilding size={16} color="white" />
                  Voir les appartements
                  <IconArrowRight size={14} color="white" />
                </button>
                <button
                  onClick={() => setCategorieActive("villas")}
                  style={{ display:"flex", alignItems:"center", gap:8, background:"white", color:"#1C1008", border:"1.5px solid rgba(28,16,8,.15)", padding:"13px 28px", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:600, cursor:"pointer" }}
                >
                  <IconVilla size={16} color="#1C1008" />
                  Voir les villas
                </button>
              </div>
            </div>
          )}

          {/* ── CAS APPARTEMENTS / VILLAS ── */}
          {categorieActive !== "hotels" && (
            <>
              {/* Compteur résultats */}
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:28, flexWrap:"wrap", gap:12 }}>
                <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, color:"#7A5A3A" }}>
                  {loading
                    ? "Chargement..."
                    : <><strong style={{ color:"#1C1008" }}>{hebergementsFiltres.length} {categorieActive === "appartements" ? "appartement" : "villa"}{hebergementsFiltres.length > 1 ? "s" : ""}</strong> trouvé{hebergementsFiltres.length > 1 ? "s" : ""}</>
                  }
                </p>
                {search && (
                  <div style={{ display:"flex", alignItems:"center", gap:8, background:"rgba(196,68,26,.08)", borderRadius:6, padding:"6px 12px" }}>
                    <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#C4441A" }}>"{search}"</span>
                    <button onClick={() => setSearch("")} style={{ background:"none", border:"none", cursor:"pointer", color:"#C4441A", display:"flex" }}>
                      <IconClose size={14} />
                    </button>
                  </div>
                )}
              </div>

              {/* Loading skeleton */}
              {loading && (
                <div className="hebergements-grid">
                  {[1,2,3,4,5,6].map(i => (
                    <div key={i} style={{ background:"white", borderRadius:16, overflow:"hidden", border:"1.5px solid rgba(28,16,8,.06)" }}>
                      <div className="pulse" style={{ height:200, background:"#F0E8D4" }} />
                      <div style={{ padding:16 }}>
                        <div className="pulse" style={{ height:20, background:"#F0E8D4", borderRadius:6, marginBottom:10, width:"70%" }} />
                        <div className="pulse" style={{ height:14, background:"#F0E8D4", borderRadius:6, marginBottom:8, width:"50%" }} />
                        <div className="pulse" style={{ height:14, background:"#F0E8D4", borderRadius:6, width:"60%" }} />
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Liste vide */}
              {!loading && hebergementsFiltres.length === 0 && (
                <div style={{ textAlign:"center", padding:"80px 20px" }}>
                  <div style={{ display:"flex", justifyContent:"center", marginBottom:20 }}>
                    <div style={{ width:80, height:80, borderRadius:"50%", background:"rgba(196,68,26,.06)", border:"1.5px solid rgba(196,68,26,.12)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      {categorieActive === "appartements"
                        ? <IconBuilding size={36} color="#C4441A" />
                        : <IconVilla size={36} color="#C4441A" />
                      }
                    </div>
                  </div>
                  <h3 style={{ fontFamily:"'Fraunces',serif", fontSize:26, fontWeight:800, marginBottom:12 }}>
                    {search ? "Aucun résultat trouvé" : `Aucun ${categorieActive === "appartements" ? "appartement" : "villa"} disponible`}
                  </h3>
                  <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:15, color:"#7A5A3A", maxWidth:440, margin:"0 auto 28px", lineHeight:1.7 }}>
                    {search
                      ? "Essayez de modifier votre recherche ou vos filtres."
                      : `Nos ${categorieActive === "appartements" ? "appartements" : "villas"} seront disponibles très prochainement. Revenez bientôt !`
                    }
                  </p>
                  {search && (
                    <button onClick={() => setSearch("")}
                      style={{ background:"#C4441A", color:"white", border:"none", padding:"12px 28px", borderRadius:8, fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:600, cursor:"pointer" }}>
                      Effacer la recherche
                    </button>
                  )}
                </div>
              )}

              {/* Grille hébergements */}
              {!loading && hebergementsFiltres.length > 0 && (
                <div className="hebergements-grid">
                  {hebergementsFiltres.map((h, i) => (
                    <div key={h.id} className="heberg-card fade-up" style={{ animationDelay: `${i * 0.06}s` }}
                     onClick={() => navigate(`/hotels/${h.id}`)}>
                      <div style={{ overflow:"hidden", position:"relative", flexShrink:0 }}>
                        <img className="heberg-img" src={h.images[0]} alt={h.nom} />
                        {/* Badge type */}
                        <div style={{ position:"absolute", top:12, left:12, background:"rgba(28,16,8,.7)", backdropFilter:"blur(6px)", borderRadius:6, padding:"4px 10px", display:"flex", alignItems:"center", gap:5 }}>
                          {h.type === "villa"
                            ? <IconVilla size={11} color="white" />
                            : <IconBuilding size={11} color="white" />
                          }
                          <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:600, color:"white" }}>
                            {h.type === "villa" ? "Villa" : "Appartement"}
                          </span>
                        </div>
                        {/* Badge note */}
                        <div style={{ position:"absolute", top:12, right:12, background:"#C4441A", borderRadius:6, padding:"4px 10px", display:"flex", alignItems:"center", gap:4 }}>
                          <IconStar size={11} color="white" />
                          <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:700, color:"white" }}>{h.note}</span>
                        </div>
                      </div>

                      <div style={{ padding:"16px", flex:1, display:"flex", flexDirection:"column" }}>
                        <Stars count={h.etoiles || 3} />
                        <h3 style={{ fontFamily:"'Fraunces',serif", fontSize:18, fontWeight:700, marginTop:8, marginBottom:6, lineHeight:1.3 }}>
                          {h.nom}
                        </h3>
                        <div style={{ display:"flex", alignItems:"center", gap:4, marginBottom:10 }}>
                          <IconPin size={12} />
                          <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"#7A5A3A" }}>
                            {h.quartier}, {h.ville}
                          </span>
                        </div>
                        <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:14 }}>
                          {(h.equipements || []).slice(0, 3).map(eq => (
                            <span key={eq} className="tag">{eq}</span>
                          ))}
                          {(h.equipements || []).length > 3 && (
                            <span className="tag">+{h.equipements.length - 3}</span>
                          )}
                        </div>
                        <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"#B8A898", marginBottom:14 }}>
                          {(h.avis || 0).toLocaleString()} avis vérifiés
                        </p>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", borderTop:"1px solid rgba(28,16,8,.06)", paddingTop:14, marginTop:"auto" }}>
                          <div>
                            <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, color:"#7A5A3A" }}>À partir de</div>
                            <div style={{ fontFamily:"'Fraunces',serif", fontSize:17, fontWeight:800, color:"#C4441A" }}>
                              {formatPrix(h.prix)}
                            </div>
                            <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, color:"#B8A898" }}>/ nuit</div>
                          </div>
                          <button className="btn-voir">
                            Voir
                            <IconArrowRight size={13} color="white" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}